import {Responsive, WidthProvider} from 'react-grid-layout';

import 'react-grid-layout/css/styles.css';

// eslint-disable-next-line new-cap
const ResponsiveGridLayout = WidthProvider(Responsive);

export default ResponsiveGridLayout;
